// extracted by mini-css-extract-plugin
export var chevronIcon = "_cz-2";
export var teamName = "_cz-1";
export var teamSwitcherButton = "_cz-0";